<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <ProductsForm :baseProducts="products" :baseProductsName="name" :loading="loading" @submit-requested="submitRequested"></ProductsForm>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ProductsForm from './ProductsForm.vue'
import router from '@/router';

export default {
    data() {
        return {
            products: null,
            name: this.$route.params.name,
            loading: true
        }
    },
    components: { ProductsForm },
    computed:
    {
        ...mapState('products', ['getProductDetailsOutput']),
    },
    methods: {
        ...mapActions('products', ['getProductDetails']),
        ...mapActions('products', ['putProduct']),
        submitRequested(products) {
            this.putProduct(products);
        },
    },
    mounted: function () {
        if (!this.$route.query.id) {
            router.push({ name: 'ProductsList' });
        }

        this.getProductDetails(this.$route.query.id);
    },
    watch:
    {
        getProductDetailsOutput: function(products)
        {
            if(!products && !products.data)
            {
                router.push({ name: 'ProductsList' });
            }
            else
            {
                this.products = products.data;
                this.loading = false;
            }
        }
    }
}
</script>